import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Components */
import HbPlaceholderFrame from '../../../../components/Placeholder/frame/HbPlaceholderFrame'

/* Constants */
import {
  ADULT_PRODUCT_IMAGE_PLACEHOLDER_SIZES,
  ADULT_PRODUCT_IMAGE_PLACEHOLDER_VIEW_TYPES
} from './AdultProductImagePlaceholderConstants'

/* Styles */
import s from './adult-product-image-placeholder.scss'

const AdultProductImagePlaceholder = memo(({className, ratio, viewType, size}) => {
  const placeholderEnabled = Boolean(ratio)

  const WrapperElement = placeholderEnabled ? HbPlaceholderFrame : 'div'
  const wrapperProps = placeholderEnabled ? {ratio} : {}

  return (
    <WrapperElement
      className={cx(s.root, className, s[viewType], s[size])}
      {...wrapperProps}>
      <div className={s.iconContainer}>
        <div className={s.icon}>
          {'+18'}
        </div>
      </div>
    </WrapperElement>
  )
})

AdultProductImagePlaceholder.propTypes = {
  className: PropTypes.string,
  ratio: PropTypes.number,
  viewType: PropTypes.oneOf(ADULT_PRODUCT_IMAGE_PLACEHOLDER_VIEW_TYPES),
  size: PropTypes.oneOf(ADULT_PRODUCT_IMAGE_PLACEHOLDER_SIZES)
}

AdultProductImagePlaceholder.defaultProps = {
  viewType: ADULT_PRODUCT_IMAGE_PLACEHOLDER_VIEW_TYPES.DEFAULT,
  size: ADULT_PRODUCT_IMAGE_PLACEHOLDER_SIZES.SMALL
}

export default AdultProductImagePlaceholder
